<template>
  <div>
    <div>
      <Dialog
        :id="'dialogWilliamHill'"
        titulo="William Hill"
        ref="dialogWilliamHill"
        :modal="true"
        :hideHeader="false"
        tamanho="lg"
        :noClassFooter="true"
      >
        <button
          type="button"
          class="btn btn-sm btn-dark"
          @click="importarWilliamHill()"
          style="margin-right: 10px"
          :disabled="mensagem !== ''"
        >
          Clique para vincular William Hill
        </button>
        <h2 class="mt-3">{{ mensagem }}</h2>
      </Dialog>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
const axios = require("axios");

import Dialog from "../components/Dialog.vue";

export default {
  name: "WilliamHill",
  components: { Dialog },
  methods: {
    async carregarItens() {
      axios
        .get(
          "https://sports.williamhill.com/data/dml01/en-gb/OB_SP9/competition/today/match-betting?page=1",
          { headers: { "Access-Control-Allow-Origin": "*" } }
        )
        .then((resp) => {
          console.log(resp.data);
        });

      console.log("carregar");

      // https://sports.williamhill.com/data/dml01/en-gb/OB_SP9/competition/today/match-betting?page=1
      /*

      var filtros = "?_limit=500";

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      var arrEventos = [];

      for(var indiceEvento=0;indiceEvento < response.data.itens.length;indiceEvento++)
      {

        var item = response.data.itens[indiceEvento];

        arrEventos.push(item);
        
      }

      this.itens = arrEventos;*/
    },
    async importarWilliamHill() {
      //* Define a mensagem
      this.mensagem = "Carregando os dados... aguarde...";

      //* Manda processar a importacao
      await api.post("/evento/import/ws-r", {});

      //* Define a mensagem
      this.mensagem = "Importação concluída!";

      this.$emit("concluido");
    },
    fechar() {
      this.mensagem = "";
      this.$refs.dialogWilliamHill.fechar();
    },
    abrir() {
      this.mensagem = "";
      this.$refs.dialogWilliamHill.abrir();
    },
  },
  data: function () {
    return {
      itens: [],
      mensagem: "",
    };
  },
  async mounted() {},
};
</script>

<style>
</style>